<script>
export default {
  name: 'lego-popover',
  methods: {
    clickOutside() {
      this.close();
    }
  }
};
</script>

<style scoped>
.lego-tooltip {
  border: 1px solid #000000;
  padding: 6px 10px;
  line-height: 18px;
  width: max-content;
  white-space: pre-wrap;
  border-radius: 4px;
  display: block;
}
</style>
